<template>
	<transition name="fade">
		<div
			v-if="visible"
			class="new-toast-container d-flex align-items-start gap-2"
		>
			<img
				v-if="type == 'danger'"
				src="@/assets/images/toast/error.svg"
				alt=""
			/>
			<img v-else src="@/assets/images/toast/toast-green.svg" alt="" />
			<div class="flex-1">
				<div class="d-flex justify-content-between">
					<p class="toast-title mb-0">
						<strong>{{ message }}</strong>
					</p>
					<img
						@click="visible = false"
						class="pointer"
						src="@/assets/images/toast/grey-close.svg"
						alt=""
					/>
				</div>
				<p v-if="description" class="toast-desc mb-0">{{ description }}</p>
			</div>
		</div>
	</transition>
</template>
  
  <script>
import { eventBus } from "@/utils/eventBus";

export default {
	data() {
		return {
			visible: false,
			message: "",
			description: "",
			type: "success",
			timeout: null,
		};
	},
	created() {
		eventBus.$on("show-toast", this.showToast);
	},
	methods: {
		showToast({
			description,
			message = "Success",
			type = "success",
			duration = 3000,
		}) {
			clearTimeout(this.timeout);
			this.message = message;
			this.description = description;
			this.type = type;
			this.visible = true;

			this.timeout = setTimeout(() => {
				this.visible = false;
			}, duration);
		},
	},
	beforeDestroy() {
		eventBus.$off("show-toast", this.showToast);
	},
};
</script>
  
  <style scoped>
.new-toast-container {
	position: fixed;
	top: 63px;
	right: 13px;
	padding: 8px 15px 8px 8px;
	border-radius: 4px;
	font-weight: bold;
	color: white;
	z-index: 9999;
	border: 1px solid #e4e4e4;
	box-shadow: 0px 0px 12px 0px #0000000d;
	background-color: #ffffff;
	width: 350px;
}
.toast-title {
	font-family: " Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
	line-height: 34px;
}
.toast-desc {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 13px;
	color: #333333;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
.flex-1 {
	flex: 1;
}
</style>
  